<template>
  <div class="page">
    <div class="pageTitleBox" style="align-items: center">
      <div class="boxNameL" v-if="this.$route.query.type == 'edit'">
        编辑优惠券
      </div>
      <div class="boxNameL" v-if="this.$route.query.type == 'add'">
        新建优惠券
      </div>
      <div class="boxNameL" v-if="this.$route.query.type == 'see'">
        查看优惠券
      </div>
      <el-button type="warning" @click="isBack" size="small">返回</el-button>
    </div>

    <div class="wrap">
      <el-form
        class="wrap_form"
        ref="form"
        :rules="rules"
        :model="coupontInfo"
        label-width="100px"
      >
        <el-form-item label="优惠券名称" label-width="100px" prop="coupon_name">
          <el-input
            size="mini"
            style="width: 200px"
            v-model="coupontInfo.coupon_name"
          ></el-input>
        </el-form-item>
        <el-form-item label="优惠券类型" class="">
          <el-select
            v-model="productTypeIds"
            placeholder="请选择"
            clearable
            @change="changeCategory"
          >
            <el-option
              v-for="item in categoryList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动类型">
          <el-radio-group
            size="mini"
            v-model="coupontInfo.activity_type"
            @change="changeType"
          >
            <el-radio disabled :label="Number(1)">满N元减M元</el-radio>
            <el-radio disabled :label="Number(2)">满N元打M折</el-radio>
            <el-radio disabled :label="Number(3)">抵扣</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="领取时间"
          label-width="100px"
          prop="receive_start_time"
        >
          <el-col :span="4">
            <el-date-picker
              style="width: 150px"
              size="mini"
              type="date"
              value-format="timestamp"
              placeholder="选择日期"
              v-model="coupontInfo.receive_start_time"
            ></el-date-picker>
          </el-col>
          <el-col class="line" :span="1" style="text-align: center">至</el-col>
          <el-col :span="2">
            <el-date-picker
              size="mini"
              placeholder="选择时间"
              value-format="timestamp"
              v-model="coupontInfo.receive_end_time"
              style="width: 150px"
            ></el-date-picker>
          </el-col>
        </el-form-item>

        <div v-if="coupontInfo.activity_type !== 3">
          <el-form-item label="活动规则" label-width="100px">
            <span style="margin: 0 5px">满</span>

            <el-input-number
              v-if="coupontInfo.activity_type == 1"
              style="width: 120px"
              size="mini"
              v-model.number="coupontInfo.money_top"
              :min="0"
            ></el-input-number>
            <el-input-number
              v-else
              style="width: 120px"
              size="mini"
              v-model.number="coupontInfo.rebate_top"
              :min="0"
            ></el-input-number>
            {{ coupontInfo.activity_type == 1 ? "减" : "打" }}
            <el-input-number
              v-if="coupontInfo.activity_type == 1"
              style="width: 120px"
              size="mini"
              v-model="coupontInfo.money_reduce"
              :min="1"
            ></el-input-number>
            <el-input-number
              v-else
              style="width: 120px"
              size="mini"
              v-model.number="coupontInfo.rebate"
              :min="0"
            ></el-input-number>
            {{ coupontInfo.activity_type == 1 ? "元" : "折"
            }}<span
              v-if="coupontInfo.activity_type == 2"
              style="margin-left: 10px; color: red"
              >示例:95折请输入95</span
            >
          </el-form-item>
          <el-form-item
            label="最高抵扣"
            label-width="80px"
            v-if="coupontInfo.activity_type == 2"
          >
            <el-input-number
              style="width: 120px"
              size="mini"
              v-model.number="coupontInfo.rebate_limit"
              :min="0"
            ></el-input-number>
            元<span style="margin-left: 10px; color: red">默认:0为不限</span>
          </el-form-item>
        </div>
        <el-form-item label="使用时间" label-width="100px">
          <el-radio-group
            size="mini"
            v-model="coupontInfo.limit_type"
            @change="changeLimitType"
          >
            <el-radio :label="Number(0)">按日期</el-radio>
            <el-radio :label="Number(1)">按天数</el-radio>
            <el-radio :label="Number(2)">按月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" label-width="100px">
          <div v-if="coupontInfo.limit_type === 0">
            <el-col :span="4">
              <el-date-picker
                size="mini"
                type="date"
                value-format="timestamp"
                placeholder="选择日期"
                v-model="coupontInfo.use_start_time"
                style="width: 150px"
              ></el-date-picker>
            </el-col>
            <el-col class="line" :span="1" style="text-align: center"
              >至</el-col
            >
            <el-col :span="3">
              <el-date-picker
                size="mini"
                type="date"
                placeholder="选择日期"
                value-format="timestamp"
                v-model="coupontInfo.use_end_time"
                style="width: 150px"
              ></el-date-picker>
            </el-col>
          </div>
          <div v-if="coupontInfo.limit_type === 1">
            自领取日起
            <el-input
              size="mini"
              style="width: 80px"
              placeholder="请输入数字"
              v-model.number="coupontInfo.use_days"
            >
            </el-input>
            天后过期
          </div>
          <div v-if="coupontInfo.limit_type === 2">
            每月可领取
            <el-input
              size="mini"
              style="width: 80px"
              placeholder="请输入数字"
              v-model.number="coupontInfo.use_days"
            >
            </el-input>
            张
          </div>
        </el-form-item>
        <el-form-item label="使用场景">
          <el-radio-group size="mini" v-model="coupontInfo.use_scene">
            <!-- <el-radio :label="Number(0)">全部</el-radio> -->
            <el-radio :label="Number(1)">线上</el-radio>
            <el-radio :label="Number(2)">线下</el-radio>
            <!-- <el-radio :label="Number(0)">全部</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动说明">
          <el-input
            type="textarea"
            :rows="2"
            style="width: 280px"
            placeholder="请输入说明"
            v-model="coupontInfo.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <!-- 右侧抵扣卷 -->
      <div class="wrap_right">
        <!-- 满减券  折扣券 -->
        <el-form>
          <el-radio-group
            v-model="coupontInfo.apply_range.apply_type"
            class="mt20"
            @change="handelShopTypeClick"
          >
            <el-radio label="1" v-show="coupontInfo.activity_type !== 3"
              >指定订单</el-radio
            >
            <el-radio label="3" v-show="coupontInfo.activity_type !== 3"
              >指定项目</el-radio
            >
            <el-radio label="2">指定商品</el-radio>
            <el-radio label="4">指定活体</el-radio>
            <el-radio label="5">指定套餐</el-radio>
          </el-radio-group>
          <!-- 指定订单 -->
          <div class="com" v-if="coupontInfo.apply_range.apply_type == 1">
            <div class="comClass">
              <div class="comTitle">类型:</div>
              <el-select
                v-model="coupontInfo.apply_range.order_type"
                filterable
                placeholder="请选择类型"
                style="width: 140px"
                size="small"
                @change="handleBrandChange"
              >
                <el-option
                  v-for="item in brandData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="comView">
              <div
                class="comItem"
                v-for="(item, index) in selectBrandIndex"
                :key="index"
              >
                <span>{{ brandData[item - 1].name }}</span>
                <span
                  class="el-icon-close"
                  @click="handleBrandClose(index)"
                ></span>
              </div>
            </div>
          </div>
          <!-- 指定项目 -->
          <div class="com" v-if="coupontInfo.apply_range.apply_type == 3">
            <div class="comClass">
              <div class="comTitle">商品类目:</div>
              <!-- 选择类目 -->
              <el-cascader
                v-model="catgouryS"
                :options="firstcatgoryData"
                :props="{ label: 'label', multiple: true, value: 'id' }"
                clearable
                @change="handleCatgoryChange"
                collapse-tags
                ref="firstcatgory"
                size="small"
              ></el-cascader>
            </div>
            <div class="comView">
              <div
                class="comItem"
                v-for="(item, index) in selectCategory"
                :key="index"
              >
                <span>{{ item.name }}</span>
                <span
                  class="el-icon-close"
                  @click="handleCategoryClose(index)"
                ></span>
              </div>
            </div>
          </div>

          <!-- 指定商品 -->
          <div
            class="com"
            v-if="
              coupontInfo.apply_range.apply_type == 2 ||
              coupontInfo.apply_range.apply_type == 5
            "
          >
            <div class="comClass">
              <div class="comTitle">
                指定{{
                  coupontInfo.apply_range.apply_type == 2 ? "商品" : "套餐"
                }}:
              </div>
            </div>
            <el-button type="warning" size="small" @click="changeShangPin"
              >选择商品</el-button
            >
            <el-button type="warning" size="small" @click="handleDeleteClick()"
              >批量删除</el-button
            >
            <el-table
              ref="multipleTable"
              :data="shopTable"
              tooltip-effect="dark"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column label="名称" width="220">
                <template slot-scope="scope">{{
                  scope.row.goods_name
                }}</template>
              </el-table-column>
              <el-table-column prop="name" label="规格" width="220">
                <template slot-scope="scope">
                  {{ scope.row.sku_value }}
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="单位"
                width="220"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.unit }}
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="220">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="delGoods(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 指定活体 -->
          <div class="com" v-if="coupontInfo.apply_range.apply_type == 4">
            <el-form-item label="">
              <div class="com">
                <div class="comClass">
                  <div class="comTitle">芯片编号:</div>
                  <el-input
                    placeholder="请输入芯片编号"
                    v-model="chinNo"
                    clearable
                    style="width: 160px; margin-right: 20px"
                    size="small"
                  ></el-input>
                  <el-button
                    type="warning"
                    size="small"
                    @click="handelAddPetClick"
                    >添加</el-button
                  >
                </div>
                <div class="comView">
                  <div
                    class="comItem"
                    v-for="(item, index) in selectPet"
                    :key="index"
                  >
                    <span>{{ item.goods_name }}</span>
                    <span
                      class="el-icon-close"
                      @click="handlePetClose(index)"
                    ></span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div style="margin: 20px auto; text-align: center" v-if="this.$route.query.type !== 'see'">
      <el-button type="warning" :loading="loadding" @click="addcoupon"
        >确定</el-button
      >
    </div>
    <!-- 添加商品 -->
    <div v-if="dialogAddGoods_state">
      <dialogAddShop
        :addShopState="dialogAddGoods_state"
        :tree.sync="tree"
        @submit="submit_dialogAddGoods"
        @closeOn="dialogAddGoods_state = false"
      ></dialogAddShop>
    </div>
  </div>
</template>
  
<script>
import { getProductTypeList, getTypeList } from "../../../api/productApi.js";
import { epromno, firstcatgory } from "../../../api/purchaseApi.js";
import dialogAddShop from "../../../components/dialog_addShop.vue";
export default {
  components: {
    // storeSelect,
    dialogAddShop,
  },
  data() {
    return {
      // 添加优惠券
      coupontInfo: {
        coupon_name: "", //优惠券名称
        receive_start_time: "", //领券开始时间
        //统一的分类信息
        category_info: {
          _id: "",
          name: "",
          code: "",
        },
        category_list: [],
        activity_type: 0, //活动类型
        receive_end_time: "", //领券结束时间
        use_start_time: "",
        use_end_time: "",
        limit_type: 0, //结束时间
        use_days: 0, //可用天数
        status: -1, //状态
        remark: "", //备注
        use_scene: 2, //场景
        money_top: 0, //满减使用要求
        money_reduce: 0, //面额
        rebate: 0, //折扣
        //折扣使用要求
        rebate_top: 0,
        // 最高抵扣金额
        rebate_limit: 0,
        // 适用范围
        apply_range: {
          apply_type: "1",
          product_list: [],
          category_list: [],
          order_type: [],
        },
      },
      //优惠券类型
      categoryList: [],
      productTypeIds: "", //选中类型id
      brandData: [], //订单列表数据
      rules: {
        coupon_name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        receive_start_time: [
          {
            required: true,
            message: "不能为空",
            trigger: "change",
          },
        ],
      },
      selectCategory: [], //选中类目
      dialogAddGoods_state: false, //添加商品弹框
      catgouryS: [], //回显

      dialogAddShop_state: false,
      tree: [], //添加商品弹框 上传显示类
      showShops: true,
      // storeIds: [],
      loadding: false,
      selectShopTable: [], //选中商品表格
      shopTable: [],
      selectPet: [], //芯片
      chinNo: "", //芯片编号 1
      selectTable: [], //选中指定商品表格
      firstcatgoryData: [],
      brandValue: "", //选中订单值
      selectBrandIndex: [], //选中订单类型
    };
  },
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    },
  },
  mounted() {
    this.getFirstcatgory();
    this.getTypeList(); //订单列表
    this.getProductTypeList();

    // 编辑
    if (this.$route.query.id) {
      this.getVirtualCouponGroupDl(this.$route.query.id);
    }
  },
  created() {},
  methods: {
    // 选择商品
    changeShangPin() {
      if (this.coupontInfo.apply_range.apply_type == 2) {
        this.tree = [
          {
            //显示所需要类目
            id: "602f1e89c904d9db7ccf3c03", //商品
          },
          {
            id: "602f1e88c904d9db7ccf3bec", //医疗
          },
          {
            id: "60210f916e6d952a3929f0eb", //虚拟
            children: [
              {
                id: "60210f916e6d952a3929f0ec",
              },
            ],
          },
          {
            id: "603f7255664b790a9c7d4f60", //活体
          },
          {
            id: "601d11cda93f55b5cf3ae2d1", //生活服务
          },
          {
            id: "601d11cfa93f55b5cf3ae2eb", //医疗服务
          },
        ];
        this.dialogAddGoods_state = true;
      } else {
        this.tree = [
     
          {
            id: "604323824335a2f958dc740a", //套餐
            children: [
              {
                id: "604323824335a2f958dc740f", //医疗类
              }
              ,{
                id:"604323834335a2f958dc7412" //商品组合类
              }
              
            ],
           

          },
        ];
        this.dialogAddGoods_state = true;
      }
    },
    // 提交
    addcoupon() {

      if (
        !this.coupontInfo.coupon_name ||
        !this.coupontInfo.receive_start_time ||
        !this.coupontInfo.receive_end_time
      ) {
        this.$message("名称,时间不能为空");
        return;
      } else {
        if (this.coupontInfo.receive_start_time) {
          this.coupontInfo.receive_start_time = this.$public.FTimeStr10(
            this.coupontInfo.receive_start_time
          );
        } else {
          this.$message("时间不能为空");
          return;
        }
        if (this.coupontInfo.receive_end_time) {
          this.coupontInfo.receive_end_time = this.$public.FTimeStr10(
            this.coupontInfo.receive_end_time
          );
        } else {
          this.$message("时间不能为空");
          return;
        }
        if (this.coupontInfo.limit_type === 0) {
          this.coupontInfo.use_days = 0;
          if (this.coupontInfo.use_start_time) {
            this.coupontInfo.use_start_time = this.$public.FTimeStr10(
              this.coupontInfo.use_start_time
            );
          } else {
            this.$message("时间不能为空");
            return;
          }
          if (this.coupontInfo.use_end_time) {
            this.coupontInfo.use_end_time = this.$public.FTimeStr10(
              this.coupontInfo.use_end_time
            );
          } else {
            this.$message("时间不能为空");
            return;
          }
        } else {
          this.coupontInfo.use_days = Number(this.coupontInfo.use_days);
        }
      }
      if (this.coupontInfo.activity_type == 2) {
        if(this.coupontInfo.rebate){
          this.coupontInfo.rebate = this.coupontInfo.rebate / 100;
        }else{
          this.$message("请输入折扣");
            return;
        }
      }
      this.coupontInfo.apply_range.apply_type = Number(
        this.coupontInfo.apply_range.apply_type
      );

      if (this.coupontInfo.apply_range.apply_type == 1) {
        this.coupontInfo.apply_range.product_list = [];
        this.coupontInfo.apply_range.category_list = [];
        this.coupontInfo.apply_range.order_type = this.selectBrandIndex;
      } else if (
        this.coupontInfo.apply_range.apply_type == 2 ||
        this.coupontInfo.apply_range.apply_type == 5
      ) {
        this.coupontInfo.apply_range.category_list = [];
        this.coupontInfo.apply_range.order_type = [];
        this.coupontInfo.apply_range.product_list = this.shopTable;
      } else if (this.coupontInfo.apply_range.apply_type == 3) {
        this.coupontInfo.apply_range.order_type = [];
        this.coupontInfo.apply_range.product_list = [];
        this.coupontInfo.apply_range.category_list = this.selectCategory;
      } else if (this.coupontInfo.apply_range.apply_type == 4) {
        this.coupontInfo.apply_range.category_list = [];
        this.coupontInfo.apply_range.order_type = [];
        this.coupontInfo.apply_range.product_list = this.selectPet;
      }
      // console.log(this.coupontInfo, "提交的信息222222222");
      if (this.$route.query.type == "edit") {
        this.coupontInfo.id = this.$route.query.id;
      }
      // console.log(this.coupontInfo, "提交的数据");
      this.$http
        .post(
          process.env.VUE_APP_Url2 + "api/product/coupons/update",
          this.coupontInfo
        )
        .then((res) => {
          if (res.code == 0) {
            // console.log("提交", res);
            this.$router.push({
              path: "/fictitious/fictitious",
            });
          }
        });
    },

    // 获取优惠券类型
    getProductTypeList() {
      getProductTypeList({
        category: "虚拟",
      }).then((res) => {
        if (res.code == 0) {
          this.categoryList = res.data[0].children[1].children;
        }
      });
    },
    // 优惠券类型
    changeCategory(val) {
      if (val) {
        this.categoryList.forEach((item) => {
          if (item.id == val) {
            // console.log(item, "改变类型");
            this.getProduct_Type(item.label);
            if (item.name == "折扣券") {
              let obj = {
                _id: item.id,
                name: item.label,
              };
              this.coupontInfo.category_info = obj;
            } else {
              let obj = {
                _id: item.id,
                name: item.label,
                code: item.code,
              };
              this.coupontInfo.category_info = obj;
            }
          }
        });
      } else {
        this.coupontInfo.category_info = null;
      }
    },
    getProduct_Type(str) {
      if (str == "满减券") {
        this.coupontInfo.activity_type = 1;
      } else if (str == "折扣券") {
        this.coupontInfo.activity_type = 2;
      } else {
        this.coupontInfo.activity_type = 3;
      }
    },

    isBack() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({
            path: "/fictitious/fictitious",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 单选 指定日期或天数
    changeLimitType() {
      if (this.coupontInfo.limit_type === 0) {
        this.coupontInfo.use_days = 1;
      } else if (this.coupontInfo.limit_type === 1) {
        this.coupontInfo.use_start_time = "";
        this.coupontInfo.use_end_time = "";
      }else if (this.coupontInfo.limit_type === 2) {
        this.coupontInfo.use_start_time = "";
        this.coupontInfo.use_end_time = "";
      }
    },

    // 添加商品
    submit_dialogAddGoods(val) {
      // console.log("已选中商品", val);
      let shopObj = {
        goods_type: val.goodsType,
      };
      //添加商品
      if (val.goodsType == 0) {
        //商品类目
        shopObj.param_type_name = "商品"; //类型名字
        shopObj.goods_id = val.goodsItem.goodsId; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = val.skuItem._id; //规格id
        shopObj.sku_value = val.skuItem.skus_name; //规格
        shopObj.packing_way_id = val.wayItem.packing_way_id; //包装方式id
        shopObj.unit = val.wayItem.packing_way_name; //包装方式名称
      } else if (val.goodsType == 6) {
        //虚拟卡
        shopObj.param_type_name = "卡"; //类型名字
        shopObj.goods_id = val.goodsItem.virtualId; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = val.skuItem.detail_id; //规格id
        shopObj.sku_value = val.skuItem.service_objectName; //规格
        shopObj.packing_way_id = ""; //包装方式id
        shopObj.unit = ""; //包装方式名称
      } else if (val.goodsType == 5) {
        //活体
        shopObj.param_type_name = "活体"; //类型名字
        shopObj.goods_id = val.goodsItem.petCategoryId; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = val.skuItem._id; //规格id
        shopObj.sku_value = val.skuItem.stars + "星"; //规格
        shopObj.packing_way_id = ""; //包装方式id
        shopObj.unit = ""; //包装方式名称
      } else if (val.goodsType == 1) {
        //医疗
        shopObj.param_type_name = "医疗"; //类型名字
        shopObj.goods_id = val.goodsItem.medical_id; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = ""; //规格id
        shopObj.sku_value = ""; //规格
        shopObj.packing_way_id = ""; //包装方式id
        shopObj.unit = ""; //包装方式名称
      } else if (val.goodsType == 2) {
        //生活服务
        shopObj.param_type_name = "生活服务"; //类型名字
        shopObj.goods_id = val.goodsItem.serviceId; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = val.skuItem.service_objectId; //规格id
        shopObj.sku_value =
          (val.skuItem.extend_attr == null ? "" : val.skuItem.extend_attr) +
          val.skuItem.service_objectName; //规格
        shopObj.packing_way_id = ""; //包装方式id
        shopObj.unit = ""; //包装方式名称
      } else if (val.goodsType == 4) {
        //医疗服务
        shopObj.param_type_name = "医疗服务"; //类型名字
        shopObj.goods_id = val.goodsItem.serviceId; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = val.skuItem.service_objectId; //规格id
        shopObj.sku_value =
          val.skuItem.extend_attr + val.skuItem.service_objectName; //规格
        shopObj.packing_way_id = ""; //包装方式id
        shopObj.unit = ""; //包装方式名称
      } else if (val.goodsType == 8) {
        //医疗服务
        shopObj.param_type_name = "套餐"; //类型名字
        shopObj.goods_id = val.goodsItem.groupId; //商品id
        shopObj.goods_name = val.goodsItem.title; //商品名字
        shopObj.sku_id = ""; //规格id
        shopObj.sku_value = ""; //规格
        shopObj.packing_way_id = ""; //包装方式id
        shopObj.unit = ""; //包装方式名称
      }
      shopObj.param_custom_code = ""; //芯片编号
      for (let i = 0; i < this.shopTable.length; i++) {
        if (shopObj.goods_type == 0) {
          if (
            shopObj.goods_id == this.shopTable[i].goods_id &&
            shopObj.sku_id == this.shopTable[i].sku_id &&
            shopObj.packing_way_id == this.shopTable[i].packing_way_id
          ) {
            this.$message({
              type: "error",
              message: "已重复添加",
            });
            return;
          }
        } else {
          if (
            shopObj.goods_id == this.shopTable[i].goods_id &&
            shopObj.sku_id == this.shopTable[i].sku_id
          ) {
            this.$message({
              type: "error",
              message: "已重复添加",
            });
            return;
          }
        }
      }
      this.shopTable.push(shopObj);
      console.log("商品列表", this.shopTable);
      this.$message({
        type: "success",
        message: "已添加",
      });
    },

    delGoods(index) {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.shopTable.splice(index, 1);
      });
    },

    getVirtualCouponGroupDl(id) {
      let params = {
        id,
      };
      this.$http
        .get(process.env.VUE_APP_Url_baseData + "/api/product/coupons", params)
        .then((res) => {
          if (res.code == 0) {
            // console.log(res.data, "详情");
            this.productTypeIds = res.data.category_info.name;
            this.coupontInfo = res.data;
            this.coupontInfo.apply_range.apply_type =
              res.data.apply_range.apply_type + "";
            this.coupontInfo.activity_type = res.data.activity_type;
            this.shopTable = res.data.apply_range.product_list || [];
            this.selectBrandIndex = res.data.apply_range.order_type || [];
            this.selectCategory = res.data.apply_range.category_list || [];
            this.selectPet = res.data.apply_range.product_list || [];
            this.coupontInfo.receive_end_time =
              res.data.receive_end_time.length == 10
                ? res.data.receive_end_time * 1000
                : res.data.receive_end_time;
            this.coupontInfo.receive_start_time =
              res.data.receive_start_time.length == 10
                ? res.data.receive_start_time * 1000
                : res.data.receive_start_time;
            this.coupontInfo.use_start_time =
              res.data.use_start_time.length == 10
                ? res.data.use_start_time * 1000
                : res.data.use_start_time;
            this.coupontInfo.use_end_time =
              res.data.use_end_time.length == 10
                ? res.data.use_end_time * 1000
                : res.data.use_end_time;
            if (this.coupontInfo.activity_type == 2) {
              this.coupontInfo.rebate = (res.data.rebate * 100);
            }
          }
        });
    },
    getStores(data) {
      this.editParams.shop_info = data;
    },

    changeType(val) {
      if (val == 2) {
        this.editParams.rebate = 1;
      }
    },
    // 获取指定商品选中
    handleSelectionChange(val) {
      this.selectTable = val;
    },
    // 指定商品批量删除
    handleDeleteClick() {
      if (this.selectTable.length == 0) {
        this.$message({
          type: "error",
          message: "请选中",
        });
        return;
      }
      for (let i = 0; i < this.selectTable.length; i++) {
        for (let j = 0; j < this.shopTable.length; j++) {
          if (this.selectTable[i].param_type_id == 0) {
            //删除商品
            if (
              this.selectTable[i].goods_id == this.shopTable[j].goods_id &&
              this.selectTable[i].skus == this.shopTable[j].skus
            ) {
              this.shopTable.splice(j, 1);
            }
          } else {
            if (this.selectTable[i].goods_id == this.shopTable[j].goods_id) {
              this.shopTable.splice(j, 1);
            }
          }
        }
      }
    },
    //切换添加产品 初始化
    handelShopTypeClick(val) {
      this.coupontInfo.apply_range.apply_type = val;
      this.selectBrandIndex = [];
      this.shopTable = [];
      this.selectCategory = [];
      this.selectPet = [];
      this.catgouryS = [];
      this.coupontInfo.apply_range.order_type = "";
      this.chinNo = "";
      this.brandValue = "";
    },
    //删除选中芯片编号
    handlePetClose(index) {
      this.selectPet.splice(index, 1);
    },
    //添加指定活体芯片1
    handelAddPetClick() {
      let params = {
        epromno: this.chinNo,
      };
      epromno(params).then((res) => {
        if (res.code == 0) {
          console.log(res.data);
          if (this.selectPet.length > 0) {
            for (let j = 0; j < this.selectPet.length; j++) {
              if (res.data.goods_id == this.selectPet[j].goods_id) {
                this.$message({
                  type: "warning",
                  message: "已重复添加",
                });
                this.chinNo = "";
                return;
              }
            }
          }
          let obj = {
            goods_id: res.data.breedInfo.id, //id
            goods_name: res.data.insideName, //mingzi
            goods_type: 5,
            packing_way_id: " ",
            sku_id: this.chinNo, //芯片号
            sku_value: res.data.insideNo, //脖圈号
            unit: "只",
          };
          this.selectPet.push(obj);
          this.chinNo = "";
          // console.log("this.selectPet", this.selectPet);
        }
      });
    },
    //删除选中商品类目
    handleCategoryClose(index) {
      this.selectCategory.splice(index, 1);
    },
    //获取选中商品类目
    handleCatgoryChange() {
      let nodesObj = this.$refs["firstcatgory"].getCheckedNodes(true);
      let categroyInfo = nodesObj.map((item) => {
        console.log(item, "item");
        return {
          _id: item.value,
          name: item.label,
          custom_code: "",
        };
      });
      this.selectCategory = categroyInfo;
      // console.log(this.selectCategory)
    },
    //获取一级分类列表
    getFirstcatgory() {
      let params = {
        category: "商品,虚拟,活体,医疗,生活服务,医疗服务,套餐",
      };
      firstcatgory(params).then((res) => {
        if (res.code == 0) {
          console.log('分类列表',res)
          this.firstcatgoryData = res.data;
        }
      });
    },
    //获取订单列表
    getTypeList() {
      getTypeList().then((res) => {
        if (res.code == 0) {
          this.brandData = res.data;
        }
      });
    },

    //删除选中品牌
    handleBrandClose(index) {
      this.selectBrandIndex.splice(index, 1);
    },
    //获取选中品牌
    handleBrandChange(value) {
      console.log(value,"value");
      for (var i = 0; i < this.selectBrandIndex.length; i++) {
        if (value == this.selectBrandIndex[i]) {
          this.$message({
            type: "warning",
            message: "已重复添加",
          });
          this.brandValue = "";
          return;
        }
      }
      this.selectBrandIndex.push(value - 0);
    },
  },
};
</script>
  
<style lang="scss" scoped="scoped">
.page {
  .wrap {
    background-color: #fff;
    padding-bottom: 20px;
    display: flex;
    .wrap_form {
      width: 50%;
      border-right: 1px solid #ebebeb;
    }

    .wrap_right {
      width: 50%;
      padding: 10px;
      .comClass {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin: 10px 0;

        .comTitle {
          margin: 10px;
        }
      }

      .comView {
        width: 94%;
        min-height: 120px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        padding: 10px 10px 0 10px;

        .comItem {
          margin-right: 6px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          padding: 0 6px 0 10px;
          background: #e6f7ff;
          border: 1px solid #91d5ff;
          line-height: 22px;
          font-size: 12px;
          color: #1890ff;
          display: inline-block;
          border-radius: 2px;

          span:nth-of-type(1) {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .searchbox {
    background-color: #fff;
    padding: 20px;
  }

  .tit {
    font-size: 16px;
    margin-bottom: 28px;

    height: 40px;
    line-height: 40px;
    border-radius: 3px;
    padding-left: 10px;

    .name {
      padding-left: 5px;
      border-left: 2px solid #f5882a;
    }
  }

  .footer {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    left: 220px;
    right: 0;
    padding-left: 20px;
    z-index: 200;
  }
  ::v-deep .el-form-item__label {
    text-align: center;
  }
}
</style>
  